import * as _4 from 'lodash4';
import { IContentTabEnumItem } from 'ui-ng-content-tabs';
import { IEnumeration } from 'utility-js-enumeration';

declare var Enumeration: IEnumeration;

interface IResourceContentTabEnumItem extends IContentTabEnumItem {
  isVisible: () => boolean;
}
export interface IResourceTabEnum extends IEnumeration {
  PLACES: IResourceContentTabEnumItem;
  PEOPLE: IResourceContentTabEnumItem;
}

export function ResourceTabEnum(
  $state: ng.ui.IStateService,
  appConfigModel: any,
  FEATURE_CONNECT: string,
  FEATURE_RESOURCES: string
) {
  const TABS = {
    PLACES: {
      tabOrder: 0,
      displayName: 'Places',
      state: 'my.resources.places',
      href: '/my/resources/places',
      view: '',
      isActive: () => {
        return $state.current.name === 'my.resources.places';
      },
      isVisible: () => appConfigModel.isFeatureEnabled(FEATURE_RESOURCES)
    },
    PEOPLE: {
      tabOrder: 1,
      displayName: 'People',
      state: 'my.resources.people',
      href: '/my/resources/people',
      view: '',
      isActive: () => {
        return $state.current.name === 'my.resources.people';
      },
      isVisible: () => appConfigModel.isFeatureEnabled(FEATURE_CONNECT)
    }
  };

  const VISIBLE_TABS: {} = _4.pickBy(TABS, (tab) => tab.isVisible());
  return Enumeration.useDefinitionAsEnum(VISIBLE_TABS);
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-resources/src/types/resource_tab_enum.ts